export const queryKeys = {
  // Consolidate all your query keys here
  auth: {
    testApi: ["auth", "test-api"] as const,
  },
  quotes: {
    email: ["quotes", "email"] as const,
  },
} as const;
